import React, { useEffect, useState, useRef, useContext } from "react";

import styles from "./index.module.css"
import "./index_global.css"
import { NAME_SERVER, WS_ROULETE } from "../../Utils/NAME_HOST";
import GameService from "../../GameService/GameService";
import Timer from "../../components/UI/Timer/Timer";
import Winner from "../../components/UI/Winner/Winner";
import Spin from "../../components/UI/Spin/Spin";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import ErrorComponent from "../../components/UI/Error/ErrorComponent";
import { useNavigate } from "react-router-dom";
import Succses from "../../components/UI/Notification/Succses";
import formatCurrency from "../../Utils/formatCurrency";
import TableBets from "../../components/UI/TableBets";
import Switch_bil from "../../components/UI/Switch_bill/Switch_bil";
import Footer from "../../components/Footer/Footer";
import Game from "./Game"
import { fillTextPage } from "../../Utils/FillTextPage";
import ManualBet from "../../components/UI/Manual_bet/ManualBet";
import Sound_play from "../../Utils/sound_play";
import { succses_bet } from "../../Utils/sounds";
import Modal from "../../components/Modals/Modal";
import HowToPlay from "../../components/Modals/components/HowToPlay/HowToPlay";


function BotsFight() {
    const { store } = useContext(Context)
    const navigate = useNavigate();
    const [loadText, setLoadText] = useState(true)
    const [choice_bil, setChoice_bil] = useState("real")
    const [demo_balance, setDemo_balance] = useState(1000000)
    const [loading, setLoading] = useState(true)
    const [status_switch_bil, setStatus_switch_bil] = useState(true);
    const [error, setError] = useState("")
    const [room, setRoom] = useState('');
    const [user, setUser] = useState('');
    const [costRoom, setCostRoom] = useState(0);
    const [load_user, setLoadUser] = useState(true);
    const [socket, setSocket] = useState(null);
    const [skin, setSkin] = useState('');
    const [type, setType] = useState('');
    const [typeString, setTypeString] = useState('');
    const [online, setOnline] = useState(0);
    const [role, setRole] = useState('');
    const [loadingGame, setLoadingGame] = useState(true)
    const [id_user, setIdUser] = useState('');
    const [stateModalTableBets, setStateModalTableBets] = useState(false);
    const [last10, setLast10] = useState([])
    const [topFiveNumbers, setTopFiveNumbers] = useState([[[2, '#960505'], 84], [[2, '#960505'], 84], [[2, '#960505'], 84], [[2, '#960505'], 84], [[2, '#960505'], 84]])
    const [tableUser, setTableUsers] = useState([])
    const [choicePay, setChoicePay] = useState('');
    const [clientUrl, setClientUrl] = useState('');
    const [winner, setWinner] = useState("");
    const [winner_name, setWinnerName] = useState("")
    const [modelInstuctionState, setModelInstuctionState] = useState(false);

    const instuction = [<>
        <div className="step_instruction">
            <span className="highlight_instruction">Ваша цель:</span> <div>Угадать, какая змейка выживет.</div>
        </div></>, <div className="step_instruction">
        <span className="highlight_instruction">Как играть:</span> Введите сумму ставки и нажмите «Поставить».
    </div>, <div className="step_instruction">
        <span className="highlight_instruction">Стол ставок:</span><img src={NAME_SERVER + "/assets/" + "table_bets.png"} width={330} style={{ borderRadius: "10px" }} />Ставки сделаны по принципу классической рулетки: можно поставить на конкретное число, сектор, ряд или цвет змейки. Система покажет коэффициент и возможный выигрыш.
    </div>, <div className="step_instruction"><img src={NAME_SERVER + "/assets/" + "bets_rouleteS.png"} width={330} style={{ borderRadius: "10px" }} />В разделе ставок вы увидите информацию о сумме ставки, выбранной опции и потенциальном выигрыше. Нажав на крестик, вы можете отменить ставку, и сумма вернётся на ваш баланс.
    </div>, <div className="step_instruction"><img src={NAME_SERVER + "/assets/" + "appear_snake.png"} width={330} style={{ borderRadius: "10px" }} />Игра начинается: змейки появляются на карте и двигаются по случайной траектории.
    </div>, <div className="step_instruction"><span className="highlight_instruction">Пример завершения игры
    </span><img src={NAME_SERVER + "/assets/" + "survive_snake.png"} width={330} style={{ borderRadius: "10px" }} />В этой игре победила красная змейка под номером 5.
    </div>,
    ]


    const [winner_balance, setWinner_balance] = useState(null);
    const [gameStatus, setGameStatus] = useState(false)
    const gameFieldSelector = useRef(null)

    const [seconds, setSeconds] = useState(null);
    const [loadingButtonBet, setLoadingButtonBet] = useState(false)
    const [loadingDeleteButtonBet, setLoadingDeleteButtonBet] = useState(false);
    const SnakeChoice = ["blue", "red", "gold", "green"]
    const ButtonsChoiceFastSum = [5, 10, 100, 500]
    const [indexSelectedSnake, setIndexSelectedSnake] = useState(0)
    const [betsInf, setBetsInf] = useState([])

    const [indexSelectedButtonsSum, setIndexSelectedButtonsSum] = useState(0)

    const [amount, setAmount] = useState(ButtonsChoiceFastSum[indexSelectedButtonsSum]);
    const [isDisableBet, setIsDisableBet] = useState(true);

    async function getRoom() {
        try {


            const response = await GameService.enter_game();

            if (response.data.msg === "ok") {
                setRoom("roulete");
                setCostRoom(0);
                setUser(store.user.name);
                setSocket(new WebSocket(WS_ROULETE))
                setRole(response.data.role);
                setIdUser(store.user.user_id);
                if (response.data.bets.length > 0) {
                    setStatus_switch_bil(false);
                }
                console.log(response.data.bets)

                setBetsInf(response.data.bets)

            } else {
                navigate(response.data.redirect)
            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)
        } finally {
            setLoading(false)
            store.setIsLoadingComponent(false)


        }
    }
    async function start() {
        await fillTextPage("roulette", store, setLoadText)

    }

    async function deleteBet(id) {
        if (!loadingButtonBet) {


            try {
                setLoadingDeleteButtonBet(true)

                const response = await GameService.delete_bet(id, choice_bil)
                if (response.status === 200) {
                    const data = response.data
                    if (data.error) {
                        store.add_message(data.msg, ErrorComponent)
                    } else {
                        if (data.msg === "ok") {

                            setBetsInf(betsInf.filter(value => value.id !== id));

                            if (betsInf.filter(value => value.id !== id).length === 0) {
                                setStatus_switch_bil(true)
                            }

                            if (data.typeBet === "real") {
                                store.user.balance = data.balance;
                            } else {
                                setDemo_balance(demo_balance + amount)
                            }

                        }
                    }
                } else {
                    store.add_message("error1", ErrorComponent)
                }
            } catch (e) {
                console.error(e)
                store.add_message("error1", ErrorComponent)
            } finally {
                setLoadingDeleteButtonBet(false)

            }
        }
    }

    async function getBet(choice) {


        try {
            setLoadingButtonBet(true)

            const response = await GameService.get_bet(amount, choice, choice_bil, demo_balance)

            if (response.status === 200) {
                Sound_play(succses_bet, store.sound);
                const data = response.data
                if (data.error) {
                    store.add_message(data.msg, ErrorComponent)
                } else if (data.msg === "ok") {
                    if (data.data_bet.type_string === "real") {
                        store.user.balance = data.balance;
                    }
                    setStatus_switch_bil(false)

                    const data_bet = data.data_bet;

                    if (store.isPhone) {
                        store.add_message(`<span>${formatCurrency(data_bet.amount, choice_bil)}</span> <i style="margin-right: 5px;margin-left: 5px" class="fa-solid fa-arrow-right"></i> <span>${formatCurrency(data_bet.winning, choice_bil)}</span>`, Succses)
                        // setMessageSuccses(`Успешно, возможный выигрыш ${data_bet.winning}`)

                    }
                    if (data_bet.type_string === "demo") {
                        setDemo_balance(demo_balance - data_bet.amount)
                    }
                    betsInf.push(data_bet)

                    // setBetsInf(betsInf)
                }
            } else {
                store.add_message("error1", ErrorComponent)
            }


        } catch (e) {
            console.error(e)
            store.add_message("error1", ErrorComponent)


        } finally {
            setLoadingButtonBet(false)
        }
    }

    useEffect(() => {
        start()
        getRoom()


    }, [])


    useEffect(() => {
        if (!loading) {
            socket.binaryType = "arraybuffer"


            const g = new Game({
                setLoadingGame,
                setTopFiveNumbers,
                setLast10,
                setWinnerName,
                setDemo_balance,
                setWinner_balance,
                setBetsInf,
                setSeconds,
                setGameStatus,
                setWinner,
                setStatus_switch_bil,
                setOnline,
                setTableUsers,
                setError,
                setLoadUser
            }, { gameFieldSelector }, store, room, user, costRoom, socket, skin, type, typeString, role, id_user, choicePay, clientUrl, gameStatus);

        }
    }, [loading]);

    useEffect(() => {


        if (store.choice_betRo) {
            getBet(store.choice_betRo)

            store.setChoice_betRoulete(null)
        }

    }, [store.choice_betRo]);

    if (loading || loadingGame || !store.load_text || loadText) {
        return (<Spin />)
    } else {


        return (
            <>
                <Modal Component={TableBets} ModelState={stateModalTableBets} setModelState={setStateModalTableBets} props={{ amount, game_status: gameStatus, closeModal: () => setStateModalTableBets(false) }} />
                <Modal ModelState={modelInstuctionState} setModelState={setModelInstuctionState} Component={HowToPlay} props={{ elements: instuction }} />

                <div className={`${styles.mainCotainerRoulete} fadeAnimationMain`} style={{ zIndex: "100" }}>


                    <div className={styles.wrapperContentGame}>

                        <div className={styles.containerGame}>
                            {winner && (
                                <Winner choice_bil={choice_bil} setDemo_balance={setDemo_balance} demo_balance={demo_balance}
                                    name={winner_name} color={winner} balance={winner_balance} />
                            )}

                            <div className={"gameCont" + (!gameStatus ? " close" : "")}>
                                {!gameStatus && (
                                    <div className={styles.timerContainer}>
                                        <Timer seconds={seconds} />


                                    </div>
                                )}
                                {!store.isPhone && <div className={styles.containerLast} style={{ position: "absolute", top: "10px", left: "30%", opacity: !gameStatus ? 1 : 0 }}>

                                    {last10.map(el =>
                                        <div className={styles.blockLast10} style={{ backgroundColor: el[1] }}>{el[0]}</div>
                                    )}
                                </div>}

                                <div className={styles.containerTop} style={{ opacity: !gameStatus ? 1 : 0 }}>

                                    <div className={styles.headerTop}>
                                        Топ 5
                                        <img src={NAME_SERVER + "/assets/" + "fire.gif"} width={30} />
                                    </div>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        {topFiveNumbers.map(el =>
                                            <div className={styles.blockLast10} style={{ backgroundColor: el[0][1] }}>{el[0][0]}</div>
                                        )}
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className={styles.containerTable}>
                            {store.isPhone&&<div className={styles.containerLast} style={{opacity: !gameStatus ? 1 : 0 }}>

                                {last10.map(el =>
                                    <div className={styles.blockLast10} style={{ backgroundColor: el[1] }}>{el[0]}</div>
                                )}
                            </div>}

                            <ManualBet styles={styles} ButtonsChoiceFastSum={ButtonsChoiceFastSum} setAmount={setAmount}
                                setIndexSelectedButtonsSum={setIndexSelectedButtonsSum} amount={amount}
                                indexSelectedButtonsSum={indexSelectedButtonsSum} />

                            {(gameStatus) ? <button style={{ background: "#4caf50a6" }} className={`${styles.button}`}>Ожидание</button> : <button className={`${styles.button} skeleton-button`} onClick={() => setStateModalTableBets(true)} disabled={false}>{"Поставить"}</button>
                            }

                            <div className={styles.containerBetsInf}>
                                {betsInf.map((value, index) =>
                                    !gameStatus ?
                                        <div className={`${styles.containerBet}`} key={index}>
                                            {SnakeChoice.includes(value.skin) ? (
                                                <div className={"select-color__coloInf selected"} style={{ cursor: "auto" }}>
                                                    <img height={30} src={NAME_SERVER + "/assets/" + value.skin + "x.png"} />
                                                </div>
                                            ) : (
                                                <div className={styles.nameBet}>{value.skin}</div>
                                            )}

                                            <div
                                                className={styles.betsAmountInf}>{formatCurrency(value.amount, value.type_string)}</div>
                                            <div style={{ color: "white" }}><i className="fa-solid fa-arrow-right"></i></div>
                                            <div
                                                className={styles.betsAmountInf}>{formatCurrency(value.winning, value.type_string)}</div>
                                            <div className={styles.blockButtonCancel} onClick={async () => {
                                                await deleteBet(value.id);
                                            }}>
                                                <i className="fa-solid fa-xmark"></i>
                                            </div>
                                        </div>
                                        : <div
                                            className={`${value.succses_state ? styles.containerBetInGameSuccses : styles.containerBetInGame}`}
                                            key={index}>
                                            {SnakeChoice.includes(value.skin) ? (
                                                <div className={"select-color__coloInf selected"} style={{ cursor: "auto" }}>
                                                    <img height={30} src={NAME_SERVER + "/assets/" + value.skin + "x.png"} />
                                                </div>
                                            ) : (
                                                <div className={styles.nameBet}>{value.skin}</div>
                                            )}

                                            <div
                                                className={styles.betsAmountInf}>{formatCurrency(value.amount, value.type_string)}</div>
                                            <div style={{ color: "white" }}><i className="fa-solid fa-arrow-right"></i></div>
                                            <div
                                                className={styles.betsAmountInf}>{formatCurrency(value.winning, value.type_string)}</div>

                                        </div>
                                )}
                            </div>
                            <div className={styles.containerButtons}><button onClick={() => setModelInstuctionState(true)} className={styles.howToPlay} style={{ background: "#0f1721" }}>Как играть <i class="fa-solid fa-question"></i></button>

                            </div>








                        </div>









                        {/* {!gameStatus && betsInf.length > 0 && !store.isPhone && (
                            <div className={styles.containerBetsInf}>
                                {betsInf.map((value, index) =>
                                    <div className={styles.containerBet} key={index}>
                                        {SnakeChoice.includes(value.skin) ? (
                                            <div className={"select-color__coloInf selected"} style={{ cursor: "auto" }}>
                                                <img height={30} src={NAME_SERVER + "/assets/" + value.skin + "x.png"} />
                                            </div>
                                        ) : (
                                            <div className={styles.nameBet}>{value.skin}</div>
                                        )}

                                        <div
                                            className={styles.betsAmountInf}>{formatCurrency(value.amount, value.type_string)}</div>
                                        <div style={{ color: "white" }}><i className="fa-solid fa-arrow-right"></i></div>
                                        <div
                                            className={styles.betsAmountInf}>{formatCurrency(value.winning, value.type_string)}</div>
                                        <div className={styles.blockButtonCancel} onClick={async () => {
                                            await deleteBet(value.id);
                                        }}>
                                            <i className="fa-solid fa-xmark"></i>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )} */}



                    </div>






                    {/*</div>*/}



                    {/*<Timer/>*/}

                </div>
                <Footer />
            </>
        )
    }

}

export default observer(BotsFight)